<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
  >

    <div class="w-100 d-flex justify-content-between align-items-center">
      <b-col
        class="content-header-left mt-1 mt-md-0"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col
            :md="getMdValue()"
            class="d-flex align-items-center mb-2"
          >
            <h2 class="content-header-title float-left pr-1 mb-0">
              {{ $route.meta.pageTitle }}
            </h2>
            <div class="breadcrumb-wrapper">
              <b-breadcrumb>
                <b-breadcrumb-item to="/">
                  <feather-icon
                    icon="HomeIcon"
                    size="16"
                    class="align-text-top"
                  />
                </b-breadcrumb-item>
                <b-breadcrumb-item
                  v-for="item in $route.meta.breadcrumb"
                  :key="item.text"
                  :active="item.active"
                  :to="item.to"
                >
                  {{ item.text }}
                </b-breadcrumb-item>
                <b-breadcrumb-item
                  v-if="formattedName"
                  class="text-primary"
                >
                  {{ formattedName }}
                </b-breadcrumb-item>
              </b-breadcrumb>
            </div>
            <span
              v-if="$route.meta.help"
            >
              <a
                :href="$route.meta.help"
                target="_blank"
              >
                <feather-icon
                  v-b-tooltip.hover.v-primary="'Click to view user guide'"
                  icon="HelpCircleIcon"
                  size="15"
                  class="cursor-pointer text-primary ml-1 ml-md-0"
                />
              </a>
            </span>
            <!-- <img
              src="/santa-sleigh.png"
              class="santa-sleigh"
            > -->
          </b-col>
          <b-col
            v-if="$route.meta.pageTitle === 'Dashboard' || $route.meta.pageTitle === 'Warehouse Dashboard'"
            md="4"
            class="mb-2 d-flex justify-content-end align-items-center"
          >
            <div class="mr-1">
              <span class="dash-refresh-span">Last Updated : </span>
              <time-ago
                class="dash-timeAgo"
                :datetime="refreshedDate ? refreshedDate : currentDate"
                refresh
                locale="en"
                :long="longString"
                :style="{color: 'black'}"
              />
              <div class="d-flex justify-content-end align-items-center">
                <div class="dash-refresh-in">
                  Refresh In
                </div>
                <countdown-timer
                  :initial-time="refreshedTime"
                  @ended="getRefreshDate"
                />
              </div>
            </div>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              size="sm"
              class="dash-refresh-button d-flex align-items-center justify-content-center"
              :disabled="isRefreshClicked"
              @click="confirmRefresh()"
            >
              <feather-icon
                icon="RefreshCwIcon"
                class="dash-refresh-icon"
                size="20"
              />
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-button
        v-if="$route.meta.suffix_button_text"
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        variant="primary"
        size="sm"
        class="mb-2 mr-1"
        :href="trackingLink"
        target="_blank"
      >
        {{ $route.meta.suffix_button_text }}
      </b-button>
    </div>
    <view-help-modal ref="viewHelpModal" />
  </b-row>
</template>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BRow,
  BCol,
  VBTooltip,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { appEnv } from '@/constants/config'
import ViewHelpModal from '@/components/Help/HelpModal.vue'
import { TimeAgo } from 'vue2-timeago'
import 'vue2-timeago/dist/vue2-timeago.css'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import CountdownTimer from './CountdownTimer.vue'

const DashboardRepository = RepositoryFactory.get('dashboard')

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    TimeAgo,
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BButton,
    ViewHelpModal,
    CountdownTimer,
  },
  data() {
    return {
      appEnv,
      longString: true,
      currentDate: new Date(),
      refreshedDate: null,
      isRefreshClicked: false,
      refreshedTime: 0,
      intervalId: null,
      previousRefreshedDate: null,
      nextRefreshDate: null,
    }
  },
  computed: {
    formattedName() {
      return this.$route.params.name ? this.$route.params.name.replace(/-/g, ' ') : ''
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.meta.pageTitle': function (newTitle) {
      if (newTitle === 'Dashboard' || newTitle === 'Warehouse Dashboard') {
        this.getRefreshDate()
      }
    },
  },
  methods: {
    getMdValue() {
      const title = this.$route.meta.pageTitle

      if (title === 'Dashboard' || title === 'Warehouse Dashboard') {
        return 8
      } if (title === 'Warehouse Operation') {
        return 10
      }
      return 9
    },
    onClickHelp(title, link) {
      this.$refs.viewHelpModal.openModal(title, link)
    },
    async refreshDashboard() {
    // Determine which refresh button to disable based on the current page title
      if (this.$route.meta.pageTitle === 'Dashboard' || this.$route.meta.pageTitle === 'Warehouse Dashboard') {
        const res = await DashboardRepository.DashboardQueueStart()
        if (res.status === 200) {
          this.getRefreshDate()
        }
      }
    },
    getRefreshDate() {
      try {
        if (this.intervalId) {
          clearInterval(this.intervalId)
        }
        this.intervalId = setInterval(async () => {
          const { data } = await DashboardRepository.getLastRefreshedTime()
          const newDate = new Date(data.last_updated_at)

          this.previousRefreshedDate = this.refreshedDate

          // Case 1: previousRefreshedDate is null
          if (!this.previousRefreshedDate) {
            clearInterval(this.intervalId)
            this.refreshedDate = newDate
            this.setNextRefresh(newDate)
            return
          }

          // Case 2: previousRefreshedDate is equal to newDate
          if (newDate.getTime() === this.previousRefreshedDate.getTime() && !this.isRefreshClicked) {
            const timeDiff = Math.floor((this.nextRefreshDate - newDate) / 1000)
            clearInterval(this.intervalId)
            if (timeDiff >= 300) {
              this.refreshedDate = newDate
              this.setNextRefresh(newDate)
            } else {
              this.setCountdownFrom()
            }
            return
          }

          // Case 3: previousRefreshedDate is less than newDate
          if (newDate > this.previousRefreshedDate) {
            clearInterval(this.intervalId)
            this.refreshedDate = newDate
            if (!this.isRefreshClicked) {
              this.setNextRefresh(newDate)
            }
            this.isRefreshClicked = false
            await this.clearWarehouseDashboardLocalStorage()
            if (this.$route.meta.pageTitle === 'Dashboard') {
              this.$root.$emit('refreshDashboardData')
            } else if (this.$route.meta.pageTitle === 'Warehouse Dashboard') {
              this.$root.$emit('refreshWarehouseDashboardData')
            }
          }
        }, 10000)
      } catch (e) {
        this.convertAndNotifyError(e)
        clearInterval(this.intervalId)
      }
    },
    setNextRefresh(newDate) {
      this.nextRefreshDate = new Date(newDate.getTime() + 5 * 60 * 1000)
      this.setCountdownFrom()
    },
    setCountdownFrom() {
      const now = new Date()
      const diffInSeconds = Math.floor((this.nextRefreshDate - now) / 1000)
      this.refreshedTime = diffInSeconds > 0 ? diffInSeconds : 0
    },
    async confirmRefresh() {
      const result = await this.$swal({
        icon: 'question',
        html: `
          <div class="text-center">
            <p class="mt-1 mb-1">
              This will auto refresh in less than <span class="text-primary">5 minutes</span>.<br />
              Do you really need to <strong>refresh</strong> now?
            </p>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
      })
      if (result.isConfirmed) {
        this.isRefreshClicked = true
        this.refreshDashboard()
      }
    },
    async clearWarehouseDashboardLocalStorage() {
      localStorage.removeItem('main-dashboard')
      localStorage.removeItem('dashboard-refresh-time')
      const keysToRemove = []

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)

        if (key.includes('warehouse-dashboard')) {
          keysToRemove.push(key)
        }
      }

      keysToRemove.forEach(key => localStorage.removeItem(key))
    },
  },
}
</script>

<style scoped>
  .breadcrumb-item a {
  text-decoration: none;
  color: inherit;
  cursor: default;
}
.santa-sleigh {
  width: 100px;
  margin-left: 20px;
  animation: animate 5s ease-in-out infinite;
}
@keyframes animate {
  0%,100% {
    transform: translateY(-15px);
  }
  50% {
    transform: translateY(15px);
  }
}
.refresh-button {
  float: right;
}

.refresh-icon {
  color: black !important;
}
.refresh-span {
  color: black !important;
  font-size: 13px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.timeAgo {
  margin-left: 5px;
  font-size: 13px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.dash-refresh-button {
  background-color: #ECF6FF !important;
  border-color: #ECF6FF !important;
}

.dash-refresh-icon {
  color: #1C1F32 !important;
}
.dash-refresh-span {
  color: #4A4E57 !important;
  font-size: 12px;
  font-weight: 500;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.dash-timeAgo {
  font-size: 12px;
  color: #4A4E57 !important;
  font-weight: 600;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.dash-refresh-in {
  font-weight: 500;
  margin-right: 5px;
}
</style>
